import { useEffect } from 'react';
import { useContent } from '@parcel2go/npm-p2g-app';
import { ConfigurableParameters } from '~/lib/configurable-parameters';

export const useQuoteContent = (courierSlug: string | null, serviceSlug: string | null) => {
  const { dispatch } = useContent();

  useEffect(() => {
    if (courierSlug && serviceSlug) {
      dispatch(
        new ConfigurableParameters({
          courier: courierSlug,
          service: serviceSlug
        })
      );
    } else {
      dispatch(new ConfigurableParameters({}));
    }
  }, [dispatch, courierSlug, serviceSlug]);
};
